module.exports = __webpack_public_path__ + "fonts/Poppins-Regular.35d26b7.ttf";